import _, {parseInt} from "lodash";
import Path from 'svg-path-generator';

export {
    processTextPathData,
}

const cos = Math.cos;
const sin = Math.sin;
const PI = Math.PI;

const processTextPathData = (textItem) => {
    /* console.log('letterSpacing: ', ((node.text().length - 1) * node.letterSpacing()));*/
    // const letterSpacingWidth = ((textItem.text.length - 1) * textItem.letterSpacing);

    const inputDetail = {
        centerX: (textItem.totalWidth) / 2,
        centerY: textItem.totalHeight / 2,
        radiusMajor: textItem.radius,
        radiusMinor: textItem.radius,
        startAngle: parseFloat(textItem.startAngle) / 180 * PI,
        sweepAngle: parseFloat(textItem.sweepAngle) / 180 * PI,
        rotation: parseFloat(textItem.rotation || 0) / 180 * PI,
    }

    // textItem.data = prepareArcSvgPathData(inputDetail);
    textItem.data = prepareArcSVGData(inputDetail);
}

/*const prepareArcSvgPathData = (inputDetail) => {
    const arcPath = Path()
        .moveTo(_.parseInt(inputDetail.x), _.parseInt(inputDetail.y))
        .ellipticalArc(inputDetail.radiusMajor, inputDetail.radiusMinor, 0, inputDetail.startAngle, inputDetail.sweepAngle, _.parseInt(inputDetail.x), _.parseInt(inputDetail.y))
        .end();

    console.log({arcPath});
    return arcPath;
}*/

const prepareArcSVGData = (inputDetail) => {
    const svgData = svgEllipseArc([inputDetail.centerX, inputDetail.centerY],
        [inputDetail.radiusMajor, inputDetail.radiusMinor],
        [inputDetail.startAngle, inputDetail.sweepAngle],
        inputDetail.rotation);
    return svgData.join(" ");
}

const matrixTimes = (([[a, b], [c, d]], [x, y]) => [a * x + b * y, c * x + d * y]);

const rotateMatrix = ((x) => {
    const cosX = cos(x);
    const sinX = sin(x);
    return [[cosX, -sinX], [sinX, cosX]];
});

const vectorAdd = (([a1, a2], [b1, b2]) => [a1 + b1, a2 + b2]);

const svgEllipseArc = (([centerX, centerY], [radiusMajor, radiusMinor], [startAngle, sweepAngle], rotation) => {
    sweepAngle = sweepAngle % (2 * PI);
    const rotationMatrix = rotateMatrix(rotation);
    // @ts-ignore
    const [sX, sY] = (vectorAdd(matrixTimes(rotationMatrix, [radiusMajor * cos(startAngle), radiusMinor * sin(startAngle)]), [centerX, centerY]));
    // @ts-ignore
    const [eX, eY] = (vectorAdd(matrixTimes(rotationMatrix, [radiusMajor * cos(startAngle + sweepAngle), radiusMinor * sin(startAngle + sweepAngle)]), [centerX, centerY]));
    const fA = ((sweepAngle > PI) ? 1 : 0);
    const fS = ((sweepAngle > 0) ? 1 : 0);
    return [" M ", parseInt(sX), " ", parseInt(sY), " A ", radiusMajor, radiusMinor, rotation / PI * 180, fA, fS, parseInt(eX), parseInt(eY)];
});
